module.exports = __webpack_public_path__ + "img/vegetable-food.37487e52.svg";